<!--ファイルアップロード/ダウンロードを行うatoms-->
<template>
  <div class="d-flex flex-row">
    <BsFileInput
      v-if="filePath == '' && !disabled"
      style="width: 100%"
      :vid="vid"
      :label="label"
      v-model="model"
      :required="required"
    />
    <TextFieldRef v-else class="mr-1" style="width: 90%" :label="label" :value="fileName" />
    <v-icon v-if="clearableComputed" class="mx-2" color="primary" @click="onClickClear"> mdi-close </v-icon>
    <v-icon v-if="filePath != ''" color="primary" @click="onClickDownload"> mdi-download </v-icon>
  </div>
</template>

<script>
import { Storage } from '@/plugins/storage'
import BsFileInput from '@/components/atoms/base/file/FileInput'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'

export default {
  name: 'FileInput',

  components: { BsFileInput, TextFieldRef },

  props: {
    value: {
      type: File,
      required: false,
    },
    filePath: {
      type: String,
      required: false,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    vid: {
      type: String,
      required: false,
      default: '',
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    fileName: {
      get() {
        let name = ''
        if (this.filePath) {
          const idx = this.filePath.lastIndexOf('/')
          if (idx > 0) {
            name = this.filePath.slice(idx + 1)
          } else {
            name = this.filePath
          }
        }
        return name
      },
    },
    filePathComputed: {
      get() {
        return this.filePath
      },
      set(value) {
        this.$emit('update:filePath', value)
      },
    },
    clearableComputed: {
      get() {
        return this.clearable && this.filePath != '' && !this.disabled
      },
    },
  },

  methods: {
    onClickDownload() {
      Storage.downloadFile(this.filePath)
    },
    onClickClear() {
      this.model = null
      this.filePathComputed = ''
    },
  },
}
</script>
